<template>
  <fragment>
    <quill-editor
      v-on="$listeners"
      v-bind="[$attrs, $props]"
      ref="quillComponent"
      :options="editorOption"
      class="quill-editor white"
      :disabled="disabled"
    />
    <div v-if="errorMessages.length > 0" class="v-text-field__details mt-4">
      <div class="v-messages theme--light error--text" role="alert">
        <div class="v-messages__wrapper">
          <div
            v-for="(message, index) in errorMessages"
            :key="`error-message-${index}`"
            class="v-messages__message"
          >
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
export default {
  data: () => ({
    editorOption: {
      modules: {
        toolbar: [
          [{ font: [] }],
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ direction: "rtl" }],
          [{ align: [] }],
          ["link", "image", "video"]
        ]
      },
      placeholder: ""
    }
  }),
  props: {
    errorMessages: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="sass">
.quill-editor
  .ql-blank, .ql-editor
    min-height: 240px !important
</style>
